import "./HeroImgStyles.css"; 
import IntroImg from "../assets/intro-bg.jpg";
import React from "react";
import { Link } from "react-router-dom";

const HeroImg = () => {
  return <div className="hero">
    <div className="mask">
      <img className= "intro-img" src = {IntroImg} alt = "IntroImg"/>
    </div>
    <div className="content">
      <p>Beyond the pixels, a little about me.</p>
      <h1>Julianne Simonette</h1>
      <div>
        <Link to = "/project" className="btn">Projects</Link>
        <Link to = "/contact" className="btn btn-light">Contact</Link>

      </div>
    </div>
  </div>;
  
};

export default HeroImg;